export const defaultLocale = 'en'
export const fallbackLocale = 'en'


const files = require.context(
    '.', // current directory
    true, // subdirectories
    /.+\.json$/ // only .json
)

let ru={}
let en={}
let de={}
let th={}
let cz={}
let cn={}

files.keys().forEach(fileName => {

    let name = fileName.replace('.json', '').replace('./', '');
    let parts = name.split('/');

    if ( parts[0]==='en') {
        en = {...en,...files(fileName)};
    }
    if ( parts[0]==='ru') {
        ru = {...ru,...files(fileName)};
    }
    if ( parts[0]==='de') {
        de = {...de,...files(fileName)};
    }
    if ( parts[0]==='th') {
        th = {...th,...files(fileName)};
    }
    if ( parts[0]==='cz') {
        cz = {...cz,...files(fileName)};
    }
    if ( parts[0]==='cn') {
        cn = {...cn,...files(fileName)};
    }

})


/**
 * Подгружаемые словари
 */
export const languages = {
    en, ru, cz, th, de, cn
}

/**
 * Языки, доступные в селекторе языков
 */
export const langs = {
    en: require("@/assets/images/flags/en.png"),
    ru: require("@/assets/images/flags/ru.png"),
    de: require("@/assets/images/flags/de.png"),
    // cz: require("@/assets/images/flags/cz.png"),
    // th: require("@/assets/images/flags/th.png"),
    // cn: require("@/assets/images/flags/cn.png"),
}
